import { render, staticRenderFns } from "./sinisters-providers-admin.vue?vue&type=template&id=0a6760a6"
import script from "./sinisters-providers-admin.vue?vue&type=script&lang=js"
export * from "./sinisters-providers-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports